import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getZombieInstanceFromPrimaryKey } from '@iotv/iotv-v3-types';
import { Grid } from '@mui/material';
import { useState } from 'react';
import { DialogWrapper } from '../../common/DiaglogWrapper';
import { DecodedPayloadPopUp } from '../../factories/DataGrid/cellFormatters/payload';
import { StripedDataGrid } from '../../factories/DataGrid/styles/striped';
import { fontSize } from '../cellFormatters/fontSize';
import { columnMap } from './config/columnMap';
import { getFlatLCDDeviceMessage } from './fns/getFlatLCDDeviceMessage';
const debug = process.env.REACT_APP_DEBUG && false;
export const LCDDeviceMessageTable = ({ selectedDevices, deviceMessages, loading, columnVisibilityModel, onColumnVisibilityModelChange, everyNth, }) => {
    const [wRef, setWRef] = useState(null);
    const getPayloadDialog = (children, header) => (_jsx(DialogWrapper, { header,
        open: true,
        setClosed: () => setWRef(null),
        children,
        fullWidth: true,
        maxWidth: 'xl' }));
    const handleCellClick = (e) => {
        const matchedKey = 'payloadStr';
        if (e.field === matchedKey) {
            const payloadStr = e.value;
            if (typeof payloadStr === 'string') {
                const eui = e.row['deviceEui'] ?? '';
                const linkType = e.row['linkType'];
                const deviceType = e.row['deviceType'];
                const timestamp = e.row['timestamp'];
                console.log(`TEMP: LCDDeviceMessageTable handleCellClick`, timestamp);
                const device = selectedDevices.find((d) => d.eui === eui) ??
                    { ...getZombieInstanceFromPrimaryKey(`Device:${eui}`), eui, deviceType };
                const port = e.row['port'] ?? null;
                debug && console.log('Device and port', { device, port });
                setWRef(getPayloadDialog(_jsx(DecodedPayloadPopUp, { timestamp, payloadStr, linkType, device, port }), 'Decoded payload'));
            }
        }
    };
    const dataGridProps = {
        onCellClick: handleCellClick,
        density: 'compact',
        columns: Object.entries(columnMap).map(([k, v]) => ({ field: k, ...v })),
        rows: deviceMessages.filter((_, i) => ((everyNth ?? 0) > 1 ? i % (everyNth ?? 0) === 0 : true)).map((dev) => getFlatLCDDeviceMessage(dev)),
        getRowClassName: (params) => (params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'),
        loading,
        columnVisibilityModel,
        onColumnVisibilityModelChange,
        rowHeight: 32,
        columnHeaderHeight: 32,
        pageSizeOptions: [100],
        disableColumnMenu: false,
        disableColumnResize: true,
        disableColumnSelector: true,
        disableVirtualization: true,
        disableRowSelectionOnClick: true,
        hideFooterSelectedRowCount: true,
        initialState: { sorting: { sortModel: [{ field: 'timestamp', sort: 'desc' }] }, pagination: { paginationModel: { pageSize: 100 } } },
        sx: {
            [`& .MuiDataGrid-cell`]: {
                ['&[data-field="consumedAirtimeSecs"], &[data-field="esp"], &[data-field="rssi"], &[data-field="snr"], &[data-field="sf"], &[data-field="power"]']: {
                    padding: 0,
                },
            },
        },
    };
    return (_jsxs(Grid, { container: true, style: { fontSize, width: '100%' }, children: [_jsx(Grid, { size: { xs: 12 }, sx: { minHeight: '20vh', maxHeight: '70vh', overflowY: 'auto' }, children: _jsx(StripedDataGrid, { style: { fontSize: 'inherit' }, ...dataGridProps }) }), wRef] }));
};
